import React, { useEffect, useState } from 'react'
import find from 'lodash/find'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import globalStore from '@/globalStore'
import { MANAGEMENT_SIDER_MENUS } from '@/layouts/components/Main/constant'
import routes from '@/utils/routes'
import UnPermission from './403'
import useAuthorized from './useAuthorized'
import styles from './index.module.less'

interface AuthorizedProps {
  children: React.ReactNode
  code?: string // 定位需要处理的页面
}
const AuthorizedPage = (props: AuthorizedProps) => {
  const [unauthorized, setUnauthorized] = useState(false)
  const globalMobx = useLocalObservable(() => globalStore)
  const history = useRouter()
  const nameRecord = find(globalMobx.corporationList, {
    corporationId: globalMobx.activeCorporationId,
  })
  const route: any = find(routes, { path: history.pathname }) || {}

  const { hasPermission } = useAuthorized(route?.code)

  const isPersonal = globalMobx.getIsPersonal()

  useEffect(() => {
    setUnauthorized(
      (isPersonal && MANAGEMENT_SIDER_MENUS.map(m => m.value).includes(history.pathname)) ||
        !hasPermission,
    )
  }, [isPersonal])

  return (
    <div className={styles.authorized}>
      {unauthorized ? (
        <UnPermission page={route.name} name={nameRecord?.corporationName} />
      ) : (
        props.children
      )}
    </div>
  )
}

export default observer(AuthorizedPage)
